module.exports = __webpack_public_path__ + "assets/img/persistLogo2.242832e6.png";